import { Row, Col, Card, Space, Statistic, Typography } from 'antd';
import { SimulationCard } from '../../../pages/Simulation/SimulationCard';
import { getColor } from '../../../pages/Simulation/utils';
import type { MarginSimulationReportData } from '../../../store/simulation/types';
const { Title } = Typography;
const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export interface SimulationMarginReportHistoricalRowProps {
  reportData: MarginSimulationReportData;
  loading: boolean;
}

export const SimulationMarginReportHistoricalRow = ({
  reportData,
  loading,
}: SimulationMarginReportHistoricalRowProps) => {
  return (
    <SimulationCard
      subHeading="Details about margin between your sell rates and the customers historical shipment cost"
      heading="Historical Savings"
    >
      <Row style={{ marginBottom: 10 }} gutter={16}>
        <Col span={8}>
          <Card loading={loading} bordered={true} style={{ height: '100%', background: '#fafafa' }}>
            <Title level={4}>Average Historical Savings (per shipment)</Title>
            <Space size={'large'}>
              <Statistic
                title={'Historical'}
                value={currencyFormatter.format(reportData?.averageHistoricalSavings)}
                precision={0}
                valueStyle={{
                  color: getColor(reportData?.averageHistoricalSavings),
                }}
              />
            </Space>
          </Card>
        </Col>
        <Col span={8}>
          <Card loading={loading} bordered={true} style={{ height: '100%', background: '#fafafa' }}>
            <Title level={4}>Total Historical Savings</Title>
            <Space size={'large'}>
              <Statistic
                title={'Historical'}
                value={currencyFormatter.format(reportData?.totalHistoricalSavings)}
                precision={0}
                valueStyle={{
                  color: getColor(reportData?.totalHistoricalSavings),
                }}
              />
            </Space>
          </Card>
        </Col>
        <Col span={8}>
          <Card loading={loading} bordered={true} style={{ height: '100%', background: '#fafafa' }}>
            <Title level={4}>Historical Savings Percentage</Title>
            <Space size={'large'}>
              <Statistic
                title={'Historical'}
                value={`${reportData?.historicalSavingsPercent}%`}
                precision={0}
                valueStyle={{
                  color: getColor(reportData?.historicalSavingsPercent),
                }}
              />
            </Space>
          </Card>
        </Col>
      </Row>
    </SimulationCard>
  );
};
